import React, {
  Component,
  Fragment,
  useContext,
  useState,
  useEffect
} from "react";

import { withRouter } from "react-router-dom";
import "./ModalExample.css";
import { Switch, Route, Link } from "react-router-dom";
import Modal from "xsolla-uikit/lib/modal";

import Head from "xsolla-uikit/lib/head";
import FormFooter from "xsolla-uikit/lib/form-footer";
import Button from "xsolla-uikit/lib/button";
import StepTabs from "xsolla-uikit/lib/step-tabs";
import Collapse from "xsolla-uikit/lib/collapse";
import SelectExample from "./SelectExample";

import {
  // FormFooter,
  ModalAlert,
  Input,
  FormGroup,
  // Modal,
  // Button,
  StatusDot,
  ContentBlock,
  Card,
  Icon,
  Select,
  // Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";
import { throws } from "assert";



function PAsbStartPopup({
  backUrl = '/site_builder',
  wizard = false, handleModal = null}) {

    const [popState, setPopState] = useState({
      wizard: wizard || 1,
      current: 1,
      name: "New Game",
      url: "new-game-KFJKHKH-09112019",
      urlShown: false,
    })


    const handleInput = (e: SyntheticInputEvent<HTMLInputElement>) =>
      setPopState({
        ...popState,
        price: e.target.value
      });

    const steps = [
      { label: "Import data" },
      { label: "Template" }
      // {label: 'Test Results', disabled: true},
    ].map((step, index) => ({
      ...step
      // onClick: this.handleStepClick(index + 1)
    }));

      return (


                <div>


                  <FormGroup indentation="lg">
                    <div className="step_tabs_pane">
                      <StepTabs current={popState.wizard} steps={steps} />
                    </div>
                  </FormGroup>

                  <div className="xsui-content-block__entry xsui-head--align-center xsui-head--indentation-sm">
                    {popState.urlShown && (
                      <FormGroup label="SKU" indentation="md">
                        <Input
                          input={{
                            // name: 'with-icon',
                            value: popState.name,
                            // extraLabel: this.currLocked ? "DEFAULT" : null
                            onChange: handleInput
                          }}
                          offset="right"
                          //   extra={
                          //     <Icon
                          //       name={this.currLocked ? "null" : "delete"}
                          //       hoverable={true}
                          //       onClick={e => this.handeCurrDel(this.id, e)}
                          // />}
                        />
                      </FormGroup>
                    )}

                    <FormGroup label="Site Title">
                      <Input
                        // size="sm"
                        name="basic-input"
                        input={{
                          value: popState.name,
                          onChange: handleInput,
                          onChange: () => {
                            void 0;
                          }
                        }}
                      />
                    </FormGroup>

                    <FormGroup
                      label="Site URL"
                      indentation="md"
                      tooltip="You can set up your own domain later"
                    >
                      <Input
                        // size="sm"
                        name="basic-input"
                        input={{
                          value: popState.url,
                          onChange: handleInput
                        }}
                      />
                    </FormGroup>

                    <FormGroup label="Import data" indentation="md">
                      <div
                      // style={{ display: 'flex', justifyContent: 'space-between', alignContent: 'stretch', flexWrap: 'wrap' }}
                      >
                        <div
                          style={{
                            // width: '48%',
                            // height: '100px',
                            marginBottom: 8
                          }}
                        >
                          <Link to="/site_builder/site/settings">
                            <Card hoverable={true}>
                              {({ hovered }) => (
                                <Fragment>
                                  <div
                                    style={{
                                      display: "grid",
                                      // gridTemplateColumns: "repeat(2, 1fr)",
                                      gridTemplateColumns:
                                        "1fr 3.5fr 0.5fr",
                                      // gridTemplateRows: '1fr 1.5fr 0.5fr',
                                      width: "100%"
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      <svg
                                        width={40}
                                        height={40}
                                        viewBox="0 0 40 40"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0)">
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M13.1041 30.1119C13.9435 30.1119 14.7667 29.7164 15.2639 28.9883C16.058 27.8301 15.7352 26.2608 14.5439 25.4887L12.5036 24.1642C12.8523 24.0732 13.2203 24.023 13.6013 24.023C15.8998 24.023 17.7626 25.834 17.7626 28.0686C17.7626 30.3033 15.8998 32.1143 13.6013 32.1143C11.364 32.1143 9.54003 30.3975 9.44318 28.2475L11.6675 29.6882C12.1065 29.9738 12.6069 30.1119 13.1041 30.1119ZM30.0787 5C32.9777 5 35.3505 7.30686 35.3505 10.1285V30.6329C35.3505 33.4545 32.9777 35.7613 30.0787 35.7613H8.98798C6.08571 35.7582 3.71289 33.4545 3.71289 30.6297V24.5346L7.46098 26.9639C7.10264 28.8627 7.67405 30.8934 9.18491 32.3622C11.6223 34.7319 15.577 34.7319 18.0144 32.3622C19.5123 30.9059 20.0902 28.8941 19.748 27.0109L27.4411 20.3101C28.8713 20.1092 30.2465 19.4752 31.3474 18.4081C34.0495 15.7811 34.0495 11.5189 31.3474 8.89185C28.6453 6.26485 24.2612 6.26485 21.5591 8.89185C20.4582 9.96211 19.8093 11.2992 19.6027 12.6895L13.2784 22.008C12.2938 22.0582 11.3188 22.3313 10.444 22.8303L3.71289 18.4677V10.1285C3.71289 7.30686 6.08571 5 8.98798 5H30.0787ZM31.3958 13.65C31.3958 10.9947 29.1812 8.84477 26.4532 8.84477C23.7253 8.84477 21.5107 10.9978 21.5107 13.65C21.5107 16.3021 23.7253 18.4551 26.4532 18.4551C29.1812 18.4551 31.3958 16.3052 31.3958 13.65ZM23.4864 13.65C23.4864 12.0587 24.8133 10.7656 26.4532 10.7656C28.0932 10.7656 29.4201 12.0556 29.4201 13.65C29.4201 15.2444 28.0932 16.5343 26.4532 16.5343C24.8133 16.5343 23.4864 15.2444 23.4864 13.65Z"
                                            fill="currentColor"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0">
                                            <rect
                                              width={40}
                                              height={40}
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      Import from Steam
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >

                                      <Link to="/site_builder/site/settings">
                                      <Button
                                        type="button"
                                        appearance="flatten"
                                      >
                                        <Icon name="arrow" />
                                      </Button>
                                      </Link>


                                    </div>
                                  </div>
                                </Fragment>
                              )}
                            </Card>
                          </Link>
                        </div>
                        <div
                          style={{
                            // width: '48%',
                            // height: '100px',
                            marginBottom: 8
                          }}
                        >
                          <Link to="/site_builder/my_project">
                            <Card hoverable={true}>
                              {({ hovered }) => (
                                <Fragment>
                                  <div
                                    style={{
                                      display: "grid",
                                      // gridTemplateColumns: "repeat(2, 1fr)",
                                      gridTemplateColumns:
                                        "1fr 3.5fr 0.5fr",
                                      // gridTemplateRows: '1fr 1.5fr 0.5fr',
                                      width: "100%"
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      <svg
                                        width={40}
                                        height={40}
                                        viewBox="0 0 40 40"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clipPath="url(#clip0)">
                                          <path
                                            d="M34.579 18.4113L29.2271 15.3679L24.7744 19.7658L29.2271 24.1112L34.5789 20.5529C34.9452 20.3297 35.1641 19.9293 35.1641 19.4824C35.1642 19.0355 34.9453 18.635 34.579 18.4113Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M27.3636 13.8292L20.9766 10.1051L6 2L22.683 18.458L27.3636 13.8292Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M6.24707 38.0001L21.0006 29.4172L26.8419 25.6565L22.6814 21.542L6.24707 38.0001Z"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M5.00002 3.54199L5 35.9437L20.8161 20L5.00002 3.54199Z"
                                            fill="currentColor"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0">
                                            <rect
                                              width={40}
                                              height={40}
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      Import from Google Play
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      <Button
                                        type="button"
                                        appearance="flatten"
                                      >
                                        <Icon name="arrow" />
                                      </Button>
                                    </div>
                                  </div>
                                </Fragment>
                              )}
                            </Card>
                          </Link>
                        </div>
                        <div
                          style={{
                            // width: '48%',
                            // height: '100px',
                            marginBottom: 8
                          }}
                        >
                          <Link to="/site_builder/my_project">
                            <Card hoverable={true}>
                              {({ hovered }) => (
                                <Fragment>
                                  <div
                                    style={{
                                      display: "grid",
                                      // gridTemplateColumns: "repeat(2, 1fr)",
                                      gridTemplateColumns:
                                        "1fr 3.5fr 0.5fr",
                                      // gridTemplateRows: '1fr 1.5fr 0.5fr',
                                      width: "100%"
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.817 19.9285L31.0795 11.727C32.6002 9.7354 32.1947 6.90588 30.1736 5.40723C28.1525 3.90841 25.2812 4.30823 23.7604 6.29988L17.1596 14.9445V9.01346C17.1596 6.5209 15.1091 4.50027 12.5798 4.50027C10.0504 4.50027 8 6.5209 8 9.01346V30.8436C8 33.3362 10.0504 35.3568 12.5798 35.3568C15.1091 35.3568 17.1596 33.3362 17.1596 30.8436V24.9126L23.7604 33.5573C24.6605 34.736 26.0334 35.3571 27.4234 35.3571C28.3819 35.3571 29.3487 35.0616 30.1736 34.4499C32.1947 32.9513 32.6002 30.1217 31.0795 28.1301L24.817 19.9285Z" fill="currentColor" />
                                      </svg>

                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      Import from KickStarter
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center"
                                      }}
                                    >
                                      <Button
                                        type="button"
                                        appearance="flatten"
                                      >
                                        <Icon name="arrow" />
                                      </Button>
                                    </div>
                                  </div>
                                </Fragment>
                              )}
                            </Card>
                          </Link>
                        </div>

                        <div
                          style={{
                            // width: '48%',
                            height: "44px",
                            marginBottom: 8,
                            display: "flex",
                            justifyContent: "flex-end"
                          }}
                        >
                          <Button
                            type="button"
                            // icon={"upload"}
                            appearance="flatten"
                          >
                            Start fresh
                            <Icon name="arrow" />
                          </Button>
                        </div>
                      </div>
                    </FormGroup>

                    <div className="ui-form__input-group ui-form__input-group--spaced" />
                  </div>
                </div>

      );
    }

export default PAsbStartPopup;